export const advanceReserveListDivided = {
  'R': [
    {
      'key': 'SC',
      'value': 'SC',
      'text': 'SIN CONTRATO',
    },
    {
      'key': 'CC',
      'value': 'CC',
      'text': 'CON CONTRATO',
    },
    {
      'key': 'EO',
      'value': 'EO',
      'text': 'ESPERA OCE',
    },
    {
      'key': 'EA',
      'value': 'EA',
      'text': 'ESPERA AUTORIZACIÓN MSP C420',
    },
    {
      'key': 'ER',
      'value': 'ER',
      'text': 'ESPERA RESOLUCIÓN ADUANA',
    },
    {
      'key': 'EC',
      'value': 'EC',
      'text': 'ESPERA CESION DE DERECHOS',
    },
  ],
  'S': [
    {
      'key': 'EF',
      'value': 'EF',
      'text': 'ESPERA FACTURA INFORMATIVA',
    },
    {
      'key': 'EN',
      'value': 'EN',
      'text': 'ESPERA NOTA VERBAL',
    },
    {
      'key': 'ER',
      'value': 'ER',
      'text': 'ESPERA RESOLUCIÓN ADUANA',
    },
    {
      'key': 'EC',
      'value': 'EC',
      'text': 'ESPERA CESION DE DERECHOS',
    },
    {
      'key': 'PL',
      'value': 'PL',
      'text': 'POR LIQUIDAR',
    },
  ],
}
;


export const advanceReserveList = [
  {
    'key': '',
    'value': '',
    'text': 'TODOS',
  },
  {
    'key': 'SC',
    'value': 'SC',
    'text': 'SIN CONTRATO',
  },
  {
    'key': 'CC',
    'value': 'CC',
    'text': 'CON CONTRATO',
  },
  {
    'key': 'EO',
    'value': 'EO',
    'text': 'ESPERA OCE',
  },
  {
    'key': 'EA',
    'value': 'EA',
    'text': 'ESPERA AUTORIZACIÓN MSP C420',
  },
  {
    'key': 'EF',
    'value': 'EF',
    'text': 'ESPERA FACTURA INFORMATIVA',
  },
  {
    'key': 'EN',
    'value': 'EN',
    'text': 'ESPERA NOTA VERBAL',
  },
  {
    'key': 'ER',
    'value': 'ER',
    'text': 'ESPERA RESOLUCIÓN ADUANA',
  },
  {
    'key': 'EC',
    'value': 'EC',
    'text': 'ESPERA CESION DE DERECHOS',
  },
  {
    'key': 'PL',
    'value': 'PL',
    'text': 'POR LIQUIDAR',
  },
];
